import React from "react";
import {
    Addons,
    Plan,
    Profile,
    Social,
    Users,
} from "./views/Settings/sections";
import {
    Activate,
    Channels,
    Clips,
    EditorPageContainer as Editor,
    Error,
    Livestream,
    Login,
    NotVerified,
    Oauth,
    Projects,
    Register,
    ResetPassword,
    Settings,
    Verify,
    Support,
} from "ui/views";

export const paths: Record<string, string> = {
    login: "/login",
    register: "/register",
    channels: "/channels",
    settings: "/settings/*",
    settingsAddons: "addons",
    settingsSocial: "social",
    settingsPublish: "publish",
    settingsUsers: "users",
    settingsProfile: "profile",
    sidebarProfile: "/settings/profile",
    settingsPlan: "plan",
    support: "/support",
    account: "/account",
    latestFragments: "/clips",
    projectsPage: "/projects",
    verifyPage: "/verify",
    activatePage: "/activate",
    notVerified: "/notverified",
    error: "/error",
    editor: "/editor",
};

export const redirects = [{ from: "/", to: paths.projectsPage, exact: true }];

export const routes = [
    { path: paths.login, element: <Login /> },
    { path: paths.register, element: <Register /> },
    { path: paths.error, element: <Error /> },
    {
        path: "/resetpassword/:token",
        element: <ResetPassword />,
    },
    {
        path: "/activate/:token",
        element: <Activate />,
    },
];

export const protectedRoutes = [
    { path: paths.projectsPage, element: <Projects /> },
    {
        path: paths.settings,
        element: <Settings />,
        children: [
            { path: paths.settingsProfile, element: <Profile /> },
            { path: paths.settingsSocial, element: <Social /> },
            { path: paths.settingsAddons, element: <Addons /> },
            { path: paths.settingsUsers, element: <Users /> },
            { path: paths.settingsPlan, element: <Plan /> },
        ],
    },
    { path: paths.latestFragments, element: <Clips /> },
    {
        path: `${paths.editor}/:channelKey/:channelID`,
        element: <Editor />,
    },
    {
        path: "/livestream/:channelName",
        element: <Livestream />,
    },
    { path: paths.channels, element: <Channels /> },
    { path: paths.support, element: <Support /> },
    {
        path: "/verify/:token",
        element: <Verify />,
    },
    {
        path: "/oauth/:platform",
        element: <Oauth />,
    },
    { path: paths.notVerified, element: <NotVerified /> },
];
